import { builtinSearch, builtinSearchAll, preloadSearch } from 'search/builtinSearch';

/**
 * Search. Built-in only since Release 1.1 (5 Nov 2026): the app downloads the search file the server
 * builds and searches it in the browser. Algolia is no longer used, and its code and key are no longer
 * in the app (see ALGOLIA-RETIREMENT.md).
 *   searchString: the best 100, for the pop-up while typing
 *   searchAll:    every match, best first, for Enter (the filtered project grid)
 */
export const searchProvider = 'builtin' as const;

const useSearch = () => ({ searchString: builtinSearch, searchAll: builtinSearchAll, preload: preloadSearch });

export default useSearch;
